import { BILLING_ENTITY } from "@/lib/offer";
import { api } from "@/lib/api";

const loadScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Opens Razorpay checkout for an order created by the backend; resolves with verified status.
export const payWithRazorpay = async (order, description) => {
  if (!(await loadScript())) throw new Error("Could not load Razorpay. Check your connection.");
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: BILLING_ENTITY,
      description,
      prefill: { name: order.name, email: order.email, contact: order.contact },
      theme: { color: "#FF2E63" },
      handler: async (res) => {
        try {
          const { data } = await api.post("/razorpay/verify", res);
          resolve(data);
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("dismissed")) },
    });
    rz.open();
  });
};
